import React from "react";
import styled from "styled-components";
import { background, BackgroundProps } from "styled-system";
import css from "@styled-system/css";

interface StyledProps extends BackgroundProps {}

const StyledContainer = styled.div<StyledProps>`
  display: flex;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-image: url("/unknownColor.png");
  background-size: contain;
  border: solid 1px;
  ${css({
    borderColor: "grey-blue",
  })}
  ${background};
`;

const ColorDisc: React.FunctionComponent<StyledProps> = ({ background }) => {
  return (
    <StyledContainer
      data-testid="colorDisc"
      background={background}
    ></StyledContainer>
  );
};

export default ColorDisc;
